// TODO: TS: check ts

import { Stack } from "@mui/material";
import React, { type CSSProperties } from "react";

import { cn } from "../utils/styling";
import { LoadingIcon } from "./LoadingIcon";

type CenterLoadingProps = {
  label?: string;
  style?: CSSProperties;
};

export const CenterLoading = ({ label, style }: CenterLoadingProps) => {
  return (
    <div
      style={{
        left: "50%",
        position: "absolute",
        top: "50%",
        transform: "translate(-50%,-50%)",
        zIndex: 99,
        ...style,
      }}
    >
      <Stack className="h-10 gap-2" flexDirection="column">
        <LoadingIcon />
        <span className="font-ds-body-regular-md">{label}</span>
      </Stack>
    </div>
  );
};

type AdornmentLoadingProps = Record<string, unknown> & {
  className?: string;
};

export const AdornmentLoading = ({ className, ...props }: AdornmentLoadingProps) => {
  return <LoadingIcon className={cn("h-4 w-4", className)} size="sm" {...props} />;
};
